import { Controller } from "@hotwired/stimulus"

// Mirrors a slider's value into a sibling label as the user drags,
// without waiting for form submit. Used by the Budget Breakdown
// Pacing field on the style step.
export default class extends Controller {
  static targets = ["input", "value"]

  update() {
    if (!this.hasInputTarget || !this.hasValueTarget) return
    const v = parseFloat(this.inputTarget.value) || 0
    this.valueTarget.textContent = v.toFixed(1)
  }
}
